import { ListFilters, listFilterQuery } from "../types/listFilters";
import apiClient from "./apiClient";
import { Order, OrdersApiResponse } from "../types/order";
import { toLegacyListResponse } from "../utils/normalizePaginatedResponse";

/**
 * Fooding orders are real product orders backed by the `Order` table.
 * Endpoint group: /api/v1/admins/orders  (distinct from shopforme / Shop With Link)
 */
const ORDERS_PATH = "orders";

export const getFoodingOrders = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  filters: ListFilters = {}
): Promise<OrdersApiResponse> => {
  try {
    const params: Record<string, string | number | boolean> = { page, limit, ...listFilterQuery(filters, ["startDate", "endDate", "userId", "paymentStatus", "shipmentStatus"]) };
    if (search) params.search = search;
    if (status) params.status = status;

    const response = await apiClient.get(ORDERS_PATH, { params });
    return toLegacyListResponse<Order, "allOrders">(response.data, "allOrders");
  } catch (error) {

    throw error;
  }
};

/** findOne returns the order object directly (not wrapped). */
export const getFoodingOrderById = async (orderId: string): Promise<any> => {
  try {
    const response = await apiClient.get(`${ORDERS_PATH}/${orderId}`);
    return response.data;
  } catch (error) {

    throw error;
  }
};

/** Update shipment status: PATCH /orders/status { orderId, newStatus }. */
export const updateFoodingOrderStatus = async (
  orderId: string,
  newStatus: string
): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/status`, { orderId, newStatus });
  } catch (error) {

    throw error;
  }
};

/**
 * Update item prices and recalculate total:
 * PATCH /orders/items-and-total { orderId, updates: [{ itemId, pricePerItem }] }
 */
export const updateFoodingOrderItemPrice = async (
  orderId: string,
  itemId: string,
  pricePerItem: number
): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/items-and-total`, {
      orderId,
      updates: [{ itemId, pricePerItem }],
    });
  } catch (error) {

    throw error;
  }
};
